import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { screenSize } from "@utils/WindowUtilities";
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    selectedDescriptor: {
      type: String,
      default: "Items"
    },
    noSelectionText: {
      type: String,
      default: "--"
    },
    placeholder: {
      type: String,
      default: undefined
    },
    uniqueKey: {
      type: String,
      required: true
    },
    displayKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      active: false,
      results: [],
      selected: [],
      preselect: [],
      text: "--"
    };
  },
  mounted() {
    $(this.$el).on("hide.bs.dropdown", () => {
      this.setActive(false);
    });
    this.$refs.input.addEventListener("click", e => {
      if (this.active) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);
    this.$refs.input.value = this.text;
    if (this.preselect && this.data.length > 0) {
      for (let i = 0; i < this.preselect.length; i++) this.toggleSelect(this.preselect[i]);
      this.preselect = [];
    }
  },
  watch: {
    data(val) {
      if (this.preselect && val.length > 0) {
        for (let i = 0; i < this.preselect.length; i++) this.toggleSelect(this.preselect[i]);
        this.preselect = [];
      }
    },
    active(val) {
      if (!val) {
        let text = this.selected.length > 0 ? `${this.selected.length} ${this.selectedDescriptor} Selected` : this.noSelectionText;
        this.$nextTick(() => {
          this.$refs.input.value = text;
          this.text = text;
        });
      }
    },
    preselect(val) {
      if (val.length > 0 && this.data.length > 0) {
        for (let i = 0; i < val.length; i++) this.toggleSelect(val[i]);
        this.preselect = [];
      }
    }
  },
  methods: {
    focus() {
      this.setActive(true);
    },
    search() {
      var alpha = (a, b) => {
        var textA = a[this.displayKey].toUpperCase();
        var textB = b[this.displayKey].toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      };
      // eslint-disable-next-line vue/no-mutating-props
      if (this.$refs.input.value == "") this.results = this.data.sort(alpha);else this.results = this.data.filter(x => {
        return x[this.displayKey].toLowerCase().indexOf(this.$refs.input.value.toLowerCase()) > -1;
      }).sort(alpha);
    },
    setActive(isActive) {
      this.active = isActive;
      if (this.active) {
        this.$refs.input.value = "";
        this.$refs.input.select();
        if (screenSize("<md")) {
          const yOffset = -(document.querySelector(".sticky-top").offsetHeight + 16 * 2.75);
          const y = this.$refs.input.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({
            top: y,
            behavior: "smooth"
          });
        }
      } else {
        if (this.$refs.input != null) {
          this.$refs.input.blur();
          this.term = this.$refs.input.value;
          this.$refs.input.value = this.text;
        }
      }
      this.$nextTick(() => {
        if (this.$refs.input != null) {
          this.search();
        }
      });
    },
    close(e) {
      if (e) e.preventDefault();
      $(this.$el.querySelector("[data-toggle=\"dropdown\"]")).dropdown("toggle");
    },
    toggleSelect(key, e) {
      let i = this.selectedIndex(key);
      if (i == -1) {
        this.selected.push({
          key,
          item: this.data.find(x => x[this.uniqueKey] == key)
        });
      } else {
        this.selected.splice(i, 1);
      }
      this.$emit("selection-change", this.selected);
      if (e) {
        e.preventDefault();
        if (e.target && e.target.blur) e.target.blur();
      }
    },
    selectedIndex(key) {
      return this.selected.findIndex(x => {
        return x.key == key;
      });
    },
    clear(e) {
      if (e) {
        e.preventDefault();
      }
      this.selected = [];
      this.$emit("selection-change", this.selected);
    },
    selectAll(e) {
      if (e) {
        e.preventDefault();
      }
      this.selected = this.results.map(x => {
        return {
          key: x[this.uniqueKey],
          item: x
        };
      });
      this.$emit("selection-change", this.selected);
    }
  }
};